export enum Action {
  UPLOAD_SUMMARY,
  GET_ADDRESS,
  ACCOUNT_OPEN,
  DICTIONARIES,
  MOBILE_DOCUMENT_UPLOAD,
  GET_TOKEN,
  VALIDATE,
  NEW_ACCOUNT,
  LOGIN,
  DATA_UPLOAD_CHOICE,
  SELECT_MOBILE_DESKTOP,
  PERSONAL_DATA_CONFIRM,
  DESKTOP_DOCUMENT_SELECTION,
  UPLOAD_TRY_AGAIN,
  MOBILE_SMS,
  CHECK_IF_DESKTOP_CAN_PROCEED,
  DESKTOP_SMS,
  VERIFY_EMAIL,
  ADDRESS_DETAILS,
  CONFIRM_SMS_CODE,
  TAX_OFFICE_DETAILS,
  CURRENCY,
  DECLARATION_ACCEPTANCE,
  CLINT_ZONE_LOGIN,
  PAYMENT,
  DESKTOP_DOCUMENT_UPLOAD,
  ABORT_MOBILE,
  MOBILE_DOCUMENT_SELECTION,
  MOBILE_RETURN_TO_DESKTOP,
  RISK_ASSESSMENT,
  MOBILE_SMS_CODE,
  GET_IDSCAN_TOKEN,
  CONFIRM_EMAIL
}

export enum ResponseStatus {
  SUCCESS = "success",
  ERROR = "error",
  CANCELLED = "cancelled",
}
